import { render } from "./CookieConsentBanner.vue?vue&type=template&id=cdd62840"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=cdd62840&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__